import './Homepage.css'
import { useEffect, useState } from 'react';

import Findus from '../components/findus/Findus.jsx'
import Navigation from '../components/navigation/Navigation';
import HomepageImage from '../components/homepageImage/HomepageImage';
import Ourhistory from '../components/history/Ourhistory';
import Opinions from '../components/opinions/Opinions';
import Reviews from '../components/reviews/Reviews';
import Castle from '../components/castle/Castle';
import Contact from '../components/contactform/Contact';
import Footer from '../components/footer/Footer';

import Aos from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next';
import LPVideo from '../components/landingpagevideo/LPVideo';

function Homepage() {

    const { t } = useTranslation()

    useEffect(() => {
        Aos.init({ duration: 1000 }); 
    }, []);

    return (
        <>
            <Navigation />
            <HomepageImage />

            <LPVideo/>


            <section className="container-lg p-0 d-flex justify-content-between align-items-center">
                <h2 className='heading'>{t("hrs.text1")}</h2>
                <hr className='heading-hr heading' />
            </section>

            <Ourhistory />

            <section className="container-lg p-0 d-flex justify-content-between align-items-center">
                <hr className='heading-hr heading' style={{ marginTop: "64px" }} />
                <h2 className='heading' style={{ marginTop: "64px" }}>{t("hrs.text2")} <span className='underline'>{t("hrs.text2-1")}</span> ?</h2>
            </section>

            <Opinions />
            <Reviews />
            <Castle />

            <Findus />
            <Contact />
            <Footer />

        </>
    )
}

export default Homepage
